import $ from "jquery";
import ImageCompare from "image-compare-viewer";

$(() => {
  const compareEls = $(".image-compare #compare");
  if (compareEls.length > 0) {
    compareEls.each((i, compareEl) => {
      let view = new ImageCompare(compareEl, { smoothing: false }).mount();
    });
  }
});
